import HomeTeamOfExpertTab from "./HomeTeamOfExpertTab";
import sp from "../../../assets/images/Footer/sp.svg";

export default function HomeTeamOfExperts() {
  return (
    <div className="w-full">
      <div className="w-full mx-auto container px-[20px] py-[50px] flex flex-col gap-3">
        <div className="w-full flex items-center justify-center gap-2">
          <div className="flex items-center justify-center gap-1 md:gap-2">
            <img src={sp} alt="ma" className="hidden md:block" />
            <p className="text-[#053CC8] text-[26px] md:text-[32px] font-semibold text-center">
              ĐỘI NGŨ CỦA CHÚNG TÔI
            </p>
          </div>
        </div>

        <div>
          <HomeTeamOfExpertTab />
        </div>
      </div>
    </div>
  );
}
